<script setup lang="ts">
interface Props {
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
})
const emit = defineEmits<{ click: [] }>()
</script>

<template>
    <v-tooltip
        location="top"
        content-class="bg-black border-sm text-tooltip"
        max-width="200"
    >
        <template #activator="{ props: bind }">
            <v-icon-btn
                v-bind="bind"
                icon="mdi-chevron-up"
                size="small"
                color="transparent"
                rounded="lg"
                :disabled="props.disabled"
                @click="emit('click')"
            />
        </template>
        Move up
    </v-tooltip>
</template>

<style scoped>

</style>
